import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useEventListener } from '@redneckz/uni-jsx/lib/hooks/useEventListener';
import { saveSessionQuery } from '../utils/getSessionQuery.js';
import { handlerDecorator } from './handlerDecorator.js';
import { applyAspects } from './useAspects/applyAspects.js';
import { useAspects } from './useAspects/useAspects.js';
export const useClickHandler = handlerDecorator(() => {
    useEffect(() => {
        saveSessionQuery(); //? Call first time for save query in sessionStorage
    }, []);
    const aspects = useAspects();
    useEventListener(globalThis, 'click', applyAspects(aspects));
});
//# sourceMappingURL=useClickHandler.js.map